import React, { useState } from "react";

interface TooltipProps {
  children: React.ReactNode;
  text: string;
}

export const Tooltip = ({ children, text }: TooltipProps) => {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <div
      className="relative"
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
      {children}

      {showTooltip && (
        <div className="absolute left-0 bottom-full mb-2 z-[1000] w-max max-w-[300px]">
          <div className="relative bg-black text-white text-sm rounded px-2 py-1 shadow-lg">
            {text}
            <div className="absolute left-1/2 transform -translate-x-1/2 -bottom-[6px] w-0 h-0 border-l-[6px] border-r-[6px] border-t-[6px] border-l-transparent border-r-transparent border-t-black" />
          </div>
        </div>
      )}
    </div>
  );
};
